export default "/images/vendor/lightbox2/src/next.png?62074ac70bd3cfc10445d325a205a3cf";